import FleetDataHub from './FleetDataHub';

/**
 * System Health: data freshness per source, plus the four health cards with
 * 7-day trends. A page of its own (not a Control Centre tab); it reuses the
 * hub's data loading rather than duplicating it.
 */
export default function SystemHealth() {
  return <FleetDataHub view="system-health" />;
}
